// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_vsB","cls2":"ArticlesFilters-cls2_PDa ArticlesFilters-cls1_vsB"};